import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import { store } from "./redux/store";
import BrandData from "./services/BrandData";
import { MobileDetectProvider } from "./context/MobileDetectContext";
import { clearMember } from "./redux/slices/Member/member";
import { navigate } from "gatsby";

const persistor = persistStore(store);

// Component to handle cross-tab logout synchronization
const CrossTabSync = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleStorageChange = (event) => {
      // When isLoggedIn key is removed (logout in another tab)
      if (event.key === "isLoggedIn" && event.newValue === null) {
        store.dispatch(clearMember());

        // Redirect to login if on protected routes
        if (
          window.location.pathname.startsWith("/account") ||
          window.location.pathname.startsWith("/dashboard")
        ) {
          navigate("/login");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return null;
};

const wrapper = ({ element }) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    let loc = document.location;
    window.dataLayer.push({
      originalLocation: loc.href,
    });
  }

  return (
    <Provider store={store}>
      <MobileDetectProvider>
        <CrossTabSync />
        {element}
        <BrandData />
      </MobileDetectProvider>
    </Provider>
  );
};

export default wrapper;
